import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = React.createElement("path", { d: "M4 20h6V4H4v16zM20 4h-6v16h6V4z" });
export default createSvgIcon(iconPath, "Pause");
//# sourceMappingURL=PauseIcon.js.map